import { Typography } from "@mui/material";
import { Image } from "../shared/Image";

const styles = {
  image: {
    display: "block",
    width: { xs: "126px", sm: "148px", lg: "168px" },
    flexShrink: 0,
  },
  text: {
    marginLeft: { xs: "10px", sm: "14px", md: 0 },
    color: "#003b73",
    fontSize: { xs: "13px", sm: "15px", lg: "18px" },
    fontWeight: 700,
    lineHeight: 1.15,
    maxWidth: { xs: "130px", sm: "165px", md: "none" },
    whiteSpace: { md: "nowrap" },
    gridColumn: { md: "1 / 2" },
    gridRow: { md: "2 / 3" },
  },
};

export const BannerImage = () => {
  return (
    <Image
      to="https://moca-ny.org"
      sx={styles.image}
      src="/images/moca_logo.png"
      alt="Moca Logo"
    />
  );
};

export const BannerTitle = () => {
  return (
    <Typography component="div" sx={styles.text}>
      Ceramic World Destinations Map
    </Typography>
  );
};
